import { EntityRoutes } from 'routes/constants';
import { CompanyIncludes } from 'services/includes';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { CompanyEntity, ENTITY_TYPE_ID_MAP, TabKeys } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const COMPANY_DRAWERS = {
  Edit: 'edit',
  Recruiters: 'recruiters',
  CompanyType: 'companyType',
  Sendout: 'sendout',
  Task: 'task'
};

export const COMPANY_QUERY_PARAMS = {
  FollowUpId: 'followupid',
  ShowOpsVerificationModal: 'showopsverificationmodal'
};

export const COMPANY_TAB_IDS = {
  Overview: TabKeys.Overview,
  JobOrders: TabKeys.JobOrders,
  Sendouts: TabKeys.Sendouts,
  Placements: TabKeys.Placements,
  FeeAgreements: TabKeys.FeeAgreements,
  HiringAuthorities: TabKeys.HiringAuthorities,
  AssociatedCompanies: TabKeys.AssociatedCompanies,
  Employees: TabKeys.Employees,
  ActionPlan: TabKeys.Tasks,
  Sales: TabKeys.Sales
};

export const COMPANY_PROFILE_CONFIG = {
  endpoint: Endpoints.Companies,
  entityTypeId: ENTITY_TYPE_ID_MAP.company,
  id: CompanyEntity.id,
  includes: () => [CompanyIncludes],
  requestAssignmentLabel: strings.inventoryProfiles.common.startRecruiting,
  route: id => EntityRoutes.CompanyProfile.replace(':id', id),
  sectionName: CompanyEntity.singular,
  tabsStorageKey: PERSISTENCE_KEYS.PROFILE_TABS.COMPANIES,
  tabsSubheader: `${CompanyEntity.singular} ${strings.inventoryProfiles.title}`,
  title: CompanyEntity.title,
  trackingUrl: Endpoints.CompanyRecentlyViewed,
  type: 'company'
};
